// Public API for the auth feature.
//
// Internal UI components (PhoneInput, CodeVerification, LogoutButton,
// InviteLanding, UnsubscribePageClient) are intentionally NOT re-exported.
// The `(auth)` route group imports them via deep paths
// (`@/features/auth/components/...`) so server components don't pull
// client-only UI into their module graph by importing types/actions.

// Session types & helpers
export type { AuthUser, ClientAuthUser } from './models/auth-user'
export { toAuthUser, toClientAuthUser } from './models/auth-user'

// Wire types
export type {
  AuthProfileWire,
  ConfirmationCode,
  UserAuth,
  LoginData,
  CountrySelector,
  SignInHandoff,
  SignInDecision,
} from './types/auth.types'
export { ConfirmationCodeType } from './types/auth.types'

// Provider + hook (the de-facto "useSession")
export { AuthProvider, AuthContext, useAuth } from './state/auth-provider'

// Server actions
export type {
  SendConfirmationCodeResult,
  ConnectDecisionState,
  ShopHandoffResult,
} from './actions/auth.actions'
export {
  login,
  logout,
  register,
  sendConfirmationCode,
  confirmPhone,
  deleteUserAccount,
  decideConnectRequest,
  switchConnectAccount,
  mintShopHandoff,
} from './actions/auth.actions'
export { confirmEmailUnsubscribe } from './actions/email-preferences.actions'

// Lib utilities
export { getPostAuthPath } from './lib/post-auth-path'
export { viewerProfileId } from './lib/viewer-profile-id'
export {
  isProtectedPath,
  PROTECTED_PATH_PREFIXES,
} from './lib/protected-path-prefixes'
export type { ProtectedPathPrefix } from './lib/protected-path-prefixes'
export { isWithinNewUserSignupWindow } from './lib/signup-window'
